var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = { 'pb-float': true }, _obj[_vm.float] = true, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }